export const BASE_PATH = "/journal";
export const COPY_REQUEST_PATH = "request-copy-cert";
export const CERTIFY_PATH = "certify-copy";
export const DOWNLOAD_EXPORT_PATH = "download-export/:documentBundleId";
